import React from 'react';
import FilteredThread from '../components/FilteredThread';

const Videos = () => {
    return (
        <FilteredThread type="video" />
    );
};

export default Videos;